export default {
  zh: {
    userPlod:'用户名',
    passwordPlod:'密码',
    errorTexl:'',
    LoginIn:'',
  },
  en: {
    userPlod:'userName',
    passwordPlod:'password',
    errorTexl:'username or password error',
    LoginIn:'Log in',
  },
  ar: { // 阿拉伯
    userPlod:'اسم المستخدم',
    passwordPlod:'كلمة المرور',
    errorTexl:'خطا فى الاسم او الرقم السرى المستخدم',
    LoginIn:'الدخول في',
  },
  tr:{ //土耳其
    passwordPlod:'parola',
    userPlod:'kullanıcı adı',
    errorTexl:'Kullanıcı adı veya şifre hatası',
    LoginIn:'Giriş Yap',
  },
   pt: {
        "userPlod": "nome de usuário",
        "passwordPlod": "senha",
        "errorTexl": "erro no nome de usuário ou na senha",
        "LoginIn": "Entrar"
    },
    id: {
        "userPlod": "nama pengguna",
        "passwordPlod": "kata sandi",
        "errorTexl": "kesalahan nama pengguna atau kata sandi",
        "LoginIn": "Masuk"
    },
    uz: {
        "userPlod": "foydalanuvchi nomi",
        "passwordPlod": "parol",
        "errorTexl": "foydalanuvchi nomi yoki parol xatosi",
        "LoginIn": "Kirish"
    },
    ru: {
        "userPlod": "имя пользователя",
        "passwordPlod": "пароль",
        "errorTexl": "ошибка имени пользователя или пароля",
        "LoginIn": "Войти"
    },
    fa: {
        "userPlod": "نام کاربری",
        "passwordPlod": "رمز عبور",
        "errorTexl": "خطای نام کاربری یا رمز عبور",
        "LoginIn": "ورود"
    }
}


// WEBPACK FOOTER //
// src/pages/app/agentlogin/lang.js